export default __webpack_public_path__ + "static/media/pear.7e221b07.webp";